/**
 * Formats a count with a maximum display value.
 * If the count exceeds the max value, it displays "max+".
 *
 * @param count - The actual count to display
 * @param maxValue - The maximum value to show before adding "+"
 *
 * @example
 * formatBoundedCount(50, 99) // "50"
 * formatBoundedCount(100, 99) // "99+"
 * formatBoundedCount(10000, 9999) // "9999+"
 */
const formatBoundedCount = (count: number, maxValue: number): string => {
  return count > maxValue ? `${maxValue}+` : String(count);
};

export default formatBoundedCount;
